import { useMemo } from "react";
import { Credit } from "@kanda-libs/ks-frontend-services";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";
import { selectors } from "store";
import creditSelectors from "store/selectors/credit";
import { jobToPaymentsWithFinanceType } from "./Payment/helpers";
import type { PaymentWithFinanceType } from "./Payment/types";

export interface JobPaymentsPropsHook {
  payments: PaymentWithFinanceType[];
  credits?: Credit[];
  isLoading: boolean;
}

export default function useJobPaymentsProps(): JobPaymentsPropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);
  const credits = useSelector(creditSelectors.getEntitiesAsArray);

  const payments = useMemo(() => jobToPaymentsWithFinanceType(job), [job]);

  return {
    payments,
    credits,
    isLoading,
  };
}
